import React from 'react';
import './Infaq.css';
import { Link} from "react-router-dom";
import infaq1 from '../images/infaq1.png';
import infaq2 from '../images/infaq2.jpg';
import infaq3 from '../images/infaq3.jpg';
import infaq4 from '../images/infaq4.png';



class Infaq extends React.Component {
   
    render () {
      return (
        <div className=" infaq jumbotron jumbotron-fluid">
          <div className="container">
            <h1>Infaq</h1>
            <p>
              Dari Abu Hurairah R.A. bahwasanya Rasulullah Shallallahu ‘Alaihi Wasallam bersabda :
              <span>
                <br />
                Tangan diatas itu lebih baik dari tangan dibawah. Dan mulailah dengan orang yang menjadi keluargamu. Dan
                sebaik-baik sedekah ialah yang diberikan di luar keperluan. Dan barangsiapa yang menahan diri (dari
                meminta-minta), maka Allah akan mencukupkan kebutuhannya Dan barangsiapa yang merasa kaya (terhadap ada
                yang ada), maka Allah akan membuatnya kaya.”
                <br />
              </span>
              Diriwayatkan oleh Imam al-Bukhâri (no. 1427) dan Muslim no.1053 (124)
            </p>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-6 mx-auto">
                <div className="card shadow">
                  <img src={infaq1} alt="BCA" className="image img-fluid" />
                  <div className="overlay overlayColor1">
                    <div className="text">
                      <span>
                        Mohon maaf, belum tersedia. <br />
                        Harap menghubungi no yang berada <Link to="/kontak"> Disini </Link> untuk berinfaq
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-6 mx-auto">
                <div className="card shadow">
                  <img src={infaq2} alt="Gopay" className="image img-fluid" />
                  <div className="overlay overlayColor2">
                    <div className="text">
                      <span>
                        Mohon maaf, belum tersedia. <br />
                        Harap menghubungi no yang berada <Link to="/kontak"> Disini </Link> untuk berinfaq
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-6 mx-auto">
                <div className="card shadow">
                  <img src={infaq3} alt="Ovo" className="image img-fluid" />
                  <div className="overlay overlayColor3">
                    <div className="text">
                      <span>
                        Mohon maaf, belum tersedia. <br />
                        Harap menghubungi no yang berada <Link to="/kontak"> Disini </Link> untuk berinfaq
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-6 mx-auto">
                <div className="card shadow">
                  <img src={infaq4} alt="Mandiri Syariah" className="image img-fluid" />
                  <div className="overlay overlayColor4">
                    <div className="text">
                      <span>
                        Mohon maaf, belum tersedia. <br />
                        Harap menghubungi no yang berada <Link to="/kontak"> Disini </Link> untuk berinfaq
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }


export default Infaq;
